import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

// spacer size
var navHeight = $('.nav_mobile_e3f1').height();
if(window.innerWidth < 783) {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight - 46 + 'px'})
} else {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight + 'px'})
}

function openMenu() {
  disableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').addClass('active');
  $('.nav_mobile_e3f1').addClass('active');
}

function closeMenu() {
  enableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').removeClass('active');
  $('.nav_mobile_e3f1').removeClass('active');
}

$('.nav_mobile_e3f1__trigger').on('click', function(e){
  e.preventDefault();
  if($(this).hasClass('active')) {
    closeMenu();
  } else {
    openMenu();
  }
});

$('.nav_mobile_e3f1__menu i').on('click', function(){
  var $li = $(this).parent();
  if($li.hasClass('active')) {
    $li.removeClass('active');
  } else {
    $li.addClass('active');
  }
});